import { Reducer } from "redux";

import defaultState from "../default-state";

// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.

export const currencies: Reducer<ReadonlyArray<Readonly<CurrencySummary>>>
	= (state = defaultState.currencies, incomingAction: IAction) => {
		switch (incomingAction.type) {
			case "LOAD_CURRENCIES":
				const action = incomingAction as ILoadCurrenciesAction;
				return action.currencies;
			default:
				return state;
		}
	};

export const configOptions: Reducer<ReadonlyArray<Readonly<ConfigOptionItem>>>
	= (state = defaultState.configOptions, incomingAction: IAction) => {
		switch (incomingAction.type) {
			case "LOAD_CONFIGOPTIONS":
				const action = incomingAction as ILoadConfigOptionsAction;
				return action.configOptions;
			default:
				return state;
		}
	};



// WEBPACK FOOTER //
// ./src/store/initialize/initialize-reducer.ts